import React from 'react';
import { FaLinkedinIn } from 'react-icons/fa';

const Footer = () => {
  return (
    <div className="w-full py-20 h-auto border-b-[1px] border-b-black grid grid-cols-1 md:grid-cols-2 gap-8">
      <div className="w-full h-full flex flex-col gap-8">
        <div className="flex gap-4">
          <a href="https://www.linkedin.com/in/aditya-raj-programmer-analyst/" target="blank">
            <span className="bannerIcon">
              <FaLinkedinIn />
            </span>
          </a>
        </div>
      </div>
      <div className="w-full h-full flex flex-col justify-center items-center">
        <p className="text-base text-center text-gray-500">
          © 2024 Aditya Raj. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
